/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import { makeStyles } from '@fluentui/react-components';

export const useStyles = makeStyles({
    confetti: {
        position: 'absolute',
        pointerEvents: 'none',
        height: '50%',
        transform: 'scale(1.5)',
        transformOrigin: 'center',
        zIndex: 100,
    },
    hero: {
        width: '140px',
        height: '140px',
        margin: '0 auto 8px auto'
    },
    heroAnimation: {
        width: '100%',
        height: '100%'
    }
});
